import React from 'react';
import { Form, Input, Checkbox } from 'antd';

const InputGroup = Input.Group;

export default function Footer(props) {
      
    var totalDolares =props.formValues.listaEfectivoDolares.reduce((a, b) => a + (b["total"] || 0), 0)
    var totalSoles =props.formValues.listaEfectivoSoles.reduce((a, b) => a + (b["total"] || 0), 0)


    return (
        <div className="row">

            <div className="col-md-9 pt-10">
            </div>

            <div className="col-md-3 pt-10">

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Efectivo S/</label>
                       <div>{totalSoles.toFixed(2)}</div>
                       </div>
                </div>

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Efectivo $</label>
                        <div>{totalDolares.toFixed(2)}</div>
                    </div>
                </div>

   {/*              <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Transferencia S/</label>
                        <div>{props.formValues.Saldo.toFixed(2)}</div>
                   </div>
                </div> */}

            </div>
        </div>
    );
}